module.exports = __webpack_public_path__ + "img/GetItOnGooglePlay-Badge-Web.e6cbb38d.svg";